import React from "react";
import './Landing.css';
import {Col, Button, Row, Container} from "react-bootstrap";
import {PAGES} from "../../scripts/constants";
import {loadMygaRates, loadRateFile} from "../../scripts/myga-data";
import TrustBoxContainer, {TRUST_PILOT_TEMPLATE, TRUST_PILOT_THEME} from "../../components/TrustPilot";
import {NassauLog} from "../../scripts/myga-utils";
import {getCookie} from "../../scripts/cookie-helper";

const currencyOptions = {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
};

class Landing extends React.Component {

  constructor(props) {
    super(props);
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    this.state = {
      rate: null,
      years: null,
      minimum: '',
      didConsent: this.cookiesDidConsent()
    }
    window.addEventListener('cookie_status_change', (e) => {
      this.setState({
        didConsent: this.cookiesDidConsent()
      })
    }, false);
  }


  pageBtnClicked = (nextPage) => {
    this.props.updatePage(nextPage);
  };

  componentDidMount() {

    // loadMygaRates()
    //   .then(data=> {
    //     NassauLog("LANDING:// myga rates: " + JSON.stringify(data));
    //
    //     //Lets get our rate and make it available
    //     let info = data.find( rate => rate.years === '7'  );
    //     let rate = parseFloat(info.rate).toFixed(2)+"%";
    //     let years = 7;
    //     this.setState({rate, years});
    //   })
    //   .catch((err)=>{
    //     NassauLog(err);
    //   });
    
    loadRateFile()
        .then(data=>{
          NassauLog(`LANDING: rateFile: ${JSON.stringify(data)}`);
          let rates = data.mygaRates;
          let info = rates.find( rate => (rate.years === '7' && rate.fwa === '0%')  );
          let rate = parseFloat(info.rate).toFixed(2)+"%";
          let minimum = info.minimum || 5000;
          let years = 7;
          this.setState({
            rate, years,minimum,
            effectiveDate: data['effectiveDate']
          });
        })
        .catch((err)=>{
          NassauLog(err);
        });


  };

  cookiesDidConsent = () => {
    return getCookie('_cookieConsent');
  }
  
  render() {
    return (
        <div className={`landing-page`}>
          <Container className="landing-page-content">
            <Row>
              <Col className="pl-0">
                <Container className="text-left landing-rate-card">
                  <Row className="">
                    <Col className="landing-rate-title pl-0">Rates</Col>
                  </Row>
                  <Row className="">
                    <Col className="landing-rate-title pl-0">As High As
                    </Col>
                  </Row>
                  <Row className="">
                    <div className="col">{this.state.years}-year period<sup>*</sup>
                    </div>
                  </Row>
                  <Row className="">
                    <Col className="">No Free Withdrawal
                    </Col>
                    {/*<Col className="">${this.state.minimum} Minimum*/}
                    {/*</Col>*/}
                  </Row>
                  <Row className="landing-rate-text">
                    <Col className="">
                      {this.state.rate}
                    </Col>
                  </Row>
                  <Row className="">
                    <Col className="">Guaranteed Rate
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>
            <Row className="pt-0">
              <Col className={'pl-0'}>
                <Container className={`landing-nav-card ${this.state.didConsent?'':'cookie-consent-on'} ${this.isMobile?'mobile':''}`}>
                  <Row className="">
                    <Col className={'pl-0'}>Shop</Col>
                  </Row>
                  <Row className="">
                    <Col className={'pl-0'}>guaranteed interest rates</Col>
                  </Row>
                  <Row className="">
                    <Col className={'pl-0'}>and duration options  </Col>
                  </Row>
                  <Row className="text-sm-right">
                    <Col className={'pl-0'}>
                      <Button id={'startNowBtn'}
                              variant={'warning'} className={'nsre-button test-enabled'}
                              onClick={() => this.pageBtnClicked(PAGES.pageDashboard)}>Start Now</Button>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>
            <Row className={'pb-1'} style={{width:'100%'}}>
              {/*<Row className={' pb-1'} style={{width: '100%'}}>*/}
              <Col className={'pl-0'}>
                <div className={`text-center landing-header-card ${this.state.didConsent?'':'cookie-consent-on'} ${this.isMobile?'mobile':''}`}>
                  Life and Annuity Customer Reviews
                </div>
              </Col>
            </Row>
            {/*<Row className={''} style={{width: '100%'}}>*/}
            {/*  <Col className={'pl-0'}>*/}
            {/*    <div className={`text-center landing-footnote-card ${this.state.didConsent?'':'cookie-consent-on'} ${this.isMobile?'mobile':''}`}>*/}
            {/*     Life and annuity stuff*/}
            {/*    </div>*/}
            {/*  </Col>*/}
            {/*</Row>*/}
            <Row className={''} style={{width: '100%'}}>
              <Col className={'pl-0'}>
                {/*<Col style={{maxWidth:'30em'}}>*/}
                {/* We use different templates based on device size, we intend to only show one of these at a time*/}
                <div className={'landing-trustpilot-card'}>
        
                  {/* Show Slider On Small (Width) Devices */}
                  <div className={'d-block d-sm-none'}>
                    <TrustBoxContainer
                        tpTemplate={TRUST_PILOT_TEMPLATE.Mini}
                        tpTheme={TRUST_PILOT_THEME.light}
                        tpHeight={'120px'}
                        tpWidth={'100%'}
                    />
                  </div>
        
                  {/* Show Carousel On Medium (Width) Devices */}
                  <div className={'d-none d-sm-block d-lg-none'}>
                    <TrustBoxContainer
                        tpTemplate={TRUST_PILOT_TEMPLATE.Carousel}
                        tpTheme={TRUST_PILOT_THEME.light}
                        tpHeight={'150px'}
                        tpWidth={'100%'}
                    />
                  </div>
        
                  {/* Show Grid on Larger Than Medium (Width) Devices */}
                  <div className={'d-none d-lg-block'}>
                    <TrustBoxContainer
                        tpTemplate={TRUST_PILOT_TEMPLATE.Carousel}
                        tpTheme={TRUST_PILOT_THEME.light}
                        tpHeight={'150px'}
                        tpWidth={'100%'}
                    />
                  </div>
      
                </div>
      
      
                {/*<TrustBoxContainer*/}
                {/*    tpTemplate={TRUST_PILOT_TEMPLATE.Mini}*/}
                {/*    tpHeight={'150px'}*/}
                {/*    tpWidth={'100%'}*/}
                {/*/>*/}
    
              </Col>
            </Row>
            <Row className={''} style={{width: '100%'}}>
              <Col className={'pl-0'}>
                <div className={`text-center landing-footnote-card ${this.state.didConsent?'':'cookie-consent-on'} ${this.isMobile?'mobile':''}`}>
                  *Nassau MYAnnuity<sup>®</sup> 7-year rate as of {this.state.effectiveDate}, subject to change and based on a {this.state.minimum.toLocaleString('en-US', currencyOptions)} minimum. Issued by Nassau Life and Annuity Company, Hartford, CT.
                </div>
              </Col>
            </Row>
          </Container>
        </div>
    );
  }

}

export default Landing;